class HeaderSearch {
    constructor() {
        this.searchForm = document.getElementById('header-search');
        this.header = document.getElementById('header');
        this.input = this.searchForm.querySelector('input[type="search"]');
        this.content = this.searchForm.querySelector('.header-search__content');
        this.openButtons = document.querySelectorAll('.header-search-open-button');
        this.clearButton = this.searchForm.querySelector('.header-search__clear-button');
        this.abortController = new AbortController();
    }
    async getSearchResults(searchTerm) {
        try {
            this.abortController = new AbortController();
            const response = await fetch(
                `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`,
                {
                    signal: this.abortController.signal,
                }
            );

            if (!response.ok) {
                throw new Error(response.status);
            }

            const text = await response.text();


            const productsList = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('#predictive-search-results-products-list');

            if (!productsList) {
                this.content.innerHTML =
                    '<p class="header-search__no-results">No products found.</p>';
                return;
            }

            this.content.innerHTML = productsList.innerHTML;
        } catch (error) {
            throw error;
        }
    }

    init() {
        console.log('HeaderSearch initialized');
        this.openButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.searchForm.classList.add('header-search--active');
                this.header.classList.add('header--search-active');
                this.input.focus();
            });
        });

        this.input.addEventListener('input', async (e) => {
            this.abortController.abort();
            const searchTerm = e.target.value.trim();
            if (searchTerm.length > 0) {
                await this.getSearchResults(searchTerm);
                this.searchForm.classList.remove('header-search--empty');
            } else {
                this.content.innerHTML = '';
                this.searchForm.classList.add('header-search--empty');
            }
        });

        document.addEventListener('click', (e) => {
            const clickInsideSearch = this.searchForm.contains(e.target);

            const clickOnOpenButton = [...this.openButtons].some(btn =>
                btn.contains(e.target)
            );

            if (!clickInsideSearch && !clickOnOpenButton) {
                this.searchForm.classList.remove('header-search--active');
                this.header.classList.remove('header--search-active');
                this.content.innerHTML = '';
                this.abortController.abort();
                this.input.value = '';
                this.searchForm.classList.add('header-search--empty');
            }
        });

        this.clearButton.addEventListener('click', (e) => {
            e.preventDefault();

            this.input.value = '';
            this.content.innerHTML = '';
            this.abortController.abort();
            this.searchForm.classList.remove('header-search--active');
            this.header.classList.remove('header--search-active');
            this.searchForm.classList.add('header-search--empty');
            this.input.blur();
        });

    }
}

document.addEventListener('DOMContentLoaded', () => {
    const headerSearch = new HeaderSearch();
    headerSearch.init();
});